<header>
  <mat-toolbar *ngIf="logado | async as isLogged">

    <button *ngIf="isLogged" mat-icon-button (click)="sidenav.toggle()">
      <mat-icon>menu</mat-icon>
    </button>

    <span routerLink="relatorio" class="col-lg-2 col-md-2 col-sm-3 col-xs-3">
      <img src="assets/images/logoBranco2.png" class="w-100" alt="">
    </span>

  </mat-toolbar>
</header>

<main>
  <mat-sidenav-container>

    <mat-sidenav #sidenav mode="over" [fixedInViewport]="true" fixedTopGap="56">

      <mat-nav-list>

        <!-- Relatórios -->
        <mat-expansion-panel>
          <mat-expansion-panel-header class="flex-row">
            <mat-icon class="mr-2">description</mat-icon>
            Relatórios
          </mat-expansion-panel-header>

          <a mat-list-item routerLink="relatorio" (click)="sidenav.close()">
            <mat-icon class="mr-2">call</mat-icon>
            Chamadas
          </a>

          <a mat-list-item routerLink="relatorio/relatorio-callcenter" (click)="sidenav.close()">
            <mat-icon class="mr-2">headset_mic</mat-icon>
            Callcenter
          </a>

          <a mat-list-item routerLink="relatorio/relatorio-agentes" (click)="sidenav.close()">
            <mat-icon class="mr-2">people</mat-icon>
            Agentes
          </a>

          <a mat-list-item routerLink="relatorio/pausas" (click)="sidenav.close()">
            <mat-icon class="mr-2">pause_circle</mat-icon>
            Pausas
          </a>

          <a mat-list-item routerLink="relatorio/relatorio-gravacoes" (click)="sidenav.close()">
            <mat-icon class="mr-2">mic</mat-icon>
            Gravações
          </a>

        </mat-expansion-panel>

        <!-- Online -->
        <mat-expansion-panel *ngIf="on | async">

          <mat-expansion-panel-header class="flex-row">

            <mat-icon class="mr-2">podcasts</mat-icon>
            Online
          </mat-expansion-panel-header>

          <a mat-list-item routerLink="online" (click)="sidenav.close()">
            <mat-icon class="mr-2">dialpad</mat-icon>
            Ramais
          </a>

          <a mat-list-item routerLink="online/filas" (click)="sidenav.close()">
            <mat-icon class="mr-2">headset_mic</mat-icon>
            Callcenter
          </a>

          <a mat-list-item routerLink="online/membros" (click)="sidenav.close()">
            <mat-icon class="mr-2">group</mat-icon>
            Agentes
          </a>

        </mat-expansion-panel>

        <!-- Diretórios -->
        <a *ngIf="dir | async" mat-list-item routerLink="diretorios" (click)="sidenav.close()">
          <mat-icon class="mr-2">folder</mat-icon>
          Diretórios
        </a>

        <a mat-list-item routerLink="conta" (click)="sidenav.close()">
          <mat-icon class="mr-2">account_circle</mat-icon>
          Conta
        </a>

        <a mat-list-item routerLink="ajuda" (click)="sidenav.close()">
          <mat-icon class="mr-2">help_outline</mat-icon>
          Ajuda
        </a>

        <a mat-list-item (click)="deslogar(); sidenav.close()">
          <mat-icon class="mr-2">logout</mat-icon>
          Logoff
        </a>

        <span mat-list-item class="footer-side">
          <mat-icon class="mr-2">info</mat-icon>
          v.<strong>0.42.1</strong>
        </span>


      </mat-nav-list>

    </mat-sidenav>

    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>

  </mat-sidenav-container>
</main>
